import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd3c7302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  class: "info mb-6 mt-4"
}

import { onMounted, ref } from 'vue'

import Modal from '@/popup/components/shared/Modal/Modal'
import Button from '@/popup/components/shared/Button.vue'
import { useAppStore } from '@/popup/store/AppStore'
import { getPreviousNetwork } from '@/shared/NetworkUtils'
import { GlobalDatabase } from '@/popup/storage/Database'
import { NetworkInfoDBSchema } from '@/shared/Database/UPSettings/models'
import Sanitize from '@/popup/components/shared/Sanitize.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkChangeConfirmation',
  setup(__props) {

const appStore = useAppStore()

const previousNetwork = ref<NetworkInfoDBSchema>()

onMounted(async () => {
  const previousNetworkId = await getPreviousNetwork()
  previousNetwork.value = await GlobalDatabase.getNetwork(previousNetworkId)
})

const onConfirm = () => {
  appStore.setHasDisplayedNetworkSwitchInfo()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "wrapper p-6",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, { class: "darker blurry" }),
      _createVNode(_unref(Modal).Content, { class: "wider" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('modal.network_switch.network_changed')), 1 /* TEXT */),
          (previousNetwork.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(Sanitize, {
                  html: 
            _ctx.$t('modal.network_switch.network_changed_info', {
              name: previousNetwork.value?.name,
            })
          
                }, null, 8 /* PROPS */, ["html"])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(Button, {
            variant: "primary",
            "is-full-width": true,
            onClick: onConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('import_waiting.confirm')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})